import { compose, setDisplayName, withProps } from 'recompose';
import { checkableOptionTypes } from '@nextiva/engagement-ui';
import { isNil, castArray } from 'lodash';
import CheckableQuestionForm from './CheckableQuestionForm/CheckableQuestionForm';

const fieldFormat = value => (isNil(value) ? [] : value);

export default compose(
  setDisplayName('MultiChoiceQuestionForm'),
  withProps({
    type: checkableOptionTypes.MULTI,
    fieldParse: castArray,
    fieldFormat,
  }),
)(CheckableQuestionForm);
